import { useEffect, useState } from 'react';

import { expVal } from '@confluence/feature-experiments';

import { fetchSnippets } from '../services/blockServiceClient.ts';
import { type Snippet } from '../snippetTypes.ts';

export const useFetchSnippets = () => {
	const [snippets, setSnippets] = useState<Snippet[]>([]);
	const [error, setError] = useState<Error | null>(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		setIsLoading(true);
		if (expVal('cc_snippets_dogfooding', 'isEnabled', false)) {
			void fetchSnippets()
				.then(setSnippets)
				.catch(setError)
				.finally(() => setIsLoading(false));
		}
	}, []);

	return [snippets, isLoading, error] as const;
};
